export const SET_PROJECTS_DATA = 'SET_PROJECTS_DATA'
